import { useMemo } from 'react';

import type { WidgetSourceScope } from '../dashboard/widget/widgets/shared/types';
import { useWidgetSourceSelection } from '../dashboard/widget/widgets/shared/useWidgetSourceSelection';
import type { InitiatorCatalogBundle } from './initiatorCatalogSeeding';

/**
 * Loads catalogs used to seed initiator widget defaults from the config API.
 */
export function useInitiatorCatalogBundle(scope: WidgetSourceScope): {
  readonly loading: boolean;
  readonly error: boolean;
  readonly bundle: InitiatorCatalogBundle;
} {
  const independentFetch = useWidgetSourceSelection({
    widget: 'timeseries',
    scope,
  });
  const windroseFetch = useWidgetSourceSelection({
    widget: 'windrose',
    scope,
  });
  const ombrothermicFetch = useWidgetSourceSelection({
    widget: 'ombrothermic',
    scope,
  });
  const entitiesFetch = useWidgetSourceSelection({
    widget: 'map',
    scope,
  });

  const bundle = useMemo(
    (): InitiatorCatalogBundle => ({
      independentDimensions: independentFetch.data,
      windroseDimensions: windroseFetch.data,
      ombrothermicDimensions: ombrothermicFetch.data,
      entities: entitiesFetch.data,
    }),
    [
      independentFetch.data,
      windroseFetch.data,
      ombrothermicFetch.data,
      entitiesFetch.data,
    ]
  );

  return {
    loading:
      independentFetch.loading ||
      windroseFetch.loading ||
      ombrothermicFetch.loading ||
      entitiesFetch.loading,
    error:
      independentFetch.error ||
      windroseFetch.error ||
      ombrothermicFetch.error ||
      entitiesFetch.error,
    bundle,
  };
}
